import { Injectable } from '@angular/core';
import { ApiConstants } from '../shared/constants/api.constants';
import { ApiServices } from '../shared/services/api.services';
import { Subject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class MaintenanceMessageService {
    enabled = new Subject();
    constructor(private apiService: ApiServices, private apiConstants: ApiConstants) {
    }

    getSchedulingDetails() {
        const header = { 'Content-Type': 'application/json' };
        return this.apiService.serviceCall(
            this.apiConstants.authUrl.scheduleDetails.url,
            this.apiConstants.authUrl.scheduleDetails.method,
            {},
            null,
            header
        );
    }
    
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/maintenance-message/maintenance-message.service.ts